import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TenantOtpService {
  getTenant(): string {
    const tenant = localStorage.getItem('otp-name') || '';
    return tenant.charAt(0) === '$' ? tenant.slice(1) : tenant;
  }

  getSource(): string {
    const source = localStorage.getItem('otp-source') || '';
    if (source) {
      return source;
    }
    const tenant = this.getTenant();
    switch (tenant) {
      case 'Bad_Neuenahr_Ahrweiler':
      case 'DevTest':
        return 'IngPlusDev';
      case 'Herzogenaurach':
      case 'QA':
      case 'Test':
        return 'IngPlus';
      default:
        return '';
    }
  }

  getLinkId(): string {
    return localStorage.getItem('otp-link-id') || '';
  }

  getUserId(): string {
    return localStorage.getItem('otp-user-id') || '';
  }

  clearOtpData(): void {
    localStorage.removeItem('otp-code');
    localStorage.removeItem('otp-link-id');
    localStorage.removeItem('otp-name');
    localStorage.removeItem('otp-source');
    localStorage.removeItem('otp-user-id');
    localStorage.removeItem('otp-id');
  }
}
